import React from 'react';
import { Package, Globe, Search, Users, DollarSign, BarChart3, Truck, ClipboardList, Zap } from 'lucide-react';
import { SectionWrapper } from './ui/SectionWrapper';
import { FeatureCard } from './ui/FeatureCard';
import { Badge } from './ui/Badge';
export function WhatIsIncluded() {
  const features = [{
    icon: <Package className="h-6 w-6" data-id="element-293" />,
    title: 'Modelos de negocio',
    description: 'Private Label, Wholesale, Online Arbitrage y Retail Arbitrage explicados con pros, contras y capital mínimo.'
  }, {
    icon: <Globe className="h-6 w-6" data-id="element-294" />,
    title: 'Vender desde otros países',
    description: 'Cómo abrir cuenta, recibir pagos, manejar logística y aduanas desde LatAm o España.'
  }, {
    icon: <Search className="h-6 w-6" data-id="element-295" />,
    title: 'Investigación de producto',
    description: 'Cómo evaluar demanda, competencia y riesgos antes de invertir un solo dólar.'
  }, {
    icon: <Users className="h-6 w-6" data-id="element-296" />,
    title: 'Proveedores',
    description: 'Dónde buscar, cómo negociar, qué preguntar y las red flags que debes conocer.'
  }, {
    icon: <DollarSign className="h-6 w-6" data-id="element-297" />,
    title: 'Costos y tarifas Amazon',
    description: 'Planes, comisiones, FBA fees, storage, publicidad y cómo estimar tu P&L por producto.'
  }, {
    icon: <BarChart3 className="h-6 w-6" data-id="element-298" />,
    title: 'Listing que convierte',
    description: 'SEO de producto, fotografía, A+ Content básico y copywriting para Amazon.'
  }, {
    icon: <Truck className="h-6 w-6" data-id="element-299" />,
    title: 'Operación FBA',
    description: 'Envíos a warehouse, gestión de inventario, reposición y SOP semanal.'
  }, {
    icon: <ClipboardList className="h-6 w-6" data-id="element-300" />,
    title: 'Plan de 30 días',
    description: 'Checklists, plantillas y un calendario de acciones para tu primer mes.'
  }];
  return <SectionWrapper data-id="element-301">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-302">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-303">
          ¿Qué incluye el ebook?
        </h2>
        <p className="text-lg text-slate-600" data-id="element-304">
          Todo lo que necesitas para empezar con Amazon FBA, en un solo lugar.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-305">
        {features.map((feature, index) => <FeatureCard key={index} icon={feature.icon} title={feature.title} description={feature.description} delay={index * 0.1} data-id="element-306" />)}
      </div>

      <div className="flex justify-center" data-id="element-307">
        <Badge variant="success" icon={<Zap className="h-4 w-4" data-id="element-309" />} className="px-4 py-2 text-base" data-id="element-308">
          Incluye plantillas y checklists descargables
        </Badge>
      </div>
    </SectionWrapper>;
}